// extracted by mini-css-extract-plugin
export default {"container":"tax_3bdlr","thumbnail":"tax_thu_3lF_","thumbnailContainer":"tax_thu_34vzW","title":"tax_tit_GT9yg","withBorder":"tax_wit_3OIT8","inner":"tax_inn_2HhU7"};